module.exports = __webpack_public_path__ + "img/26.417601cc.png";